import { Flex, Text } from "@mantine/core";
import useGetAcessos from "./useGetAcessos";

const TextAcesso = ({ id }: { id: TQuestionario["id"] }) => {
  const { data } = useGetAcessos({ id });
  return (
    <>
      <Flex mih={50} gap="xs" justify="center" align="flex-start" direction="column" wrap="wrap">
        <Text fw={300} fz="xs">
          Quantidade de acessos
        </Text>
        <Text fw={500} fz="md">
          {data?.length}
        </Text>
      </Flex>
    </>
  );
};

export default TextAcesso;
